const BASE_URL_SERVER = `${process.env.VUE_APP_SERVER_URL}`;

import axios from "axios";

const API_ENDPOINT = {
    SEND: "/api/send-email/contact",
    RESET_PASSWORD: "/api/send-email/reset-password",
}

class EmailService {
    send = (data) => {
        return axios.post(BASE_URL_SERVER + API_ENDPOINT.SEND, data);
    };

    resetPassword = (data) => {
        const userLocal = localStorage.getItem('user');
        const user = JSON.parse(userLocal);

        const config = {
            headers: {
                'content-type': 'application/json',
                'Authorization': `Bearer ${user.jwt}`
            }
        };
        return axios.post(BASE_URL_SERVER + API_ENDPOINT.RESET_PASSWORD, data, config);
    };
}

const emailService = new EmailService();
export default emailService;